import { useCallback, useRef, useState } from 'react';

import type { SliderRef } from './Slider.types';

export function useSliderController() {
  const ref = useRef<SliderRef>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(false);

  const onSlideChange = useCallback(
    (slide: number, state: { isFirst: boolean; isLast: boolean }) => {
      setCurrentSlide(slide);
      setIsFirstSlide(state.isFirst);
      setIsLastSlide(state.isLast);
    },
    []
  );

  const prev = useCallback(() => ref.current?.prev(), []);
  const next = useCallback(() => ref.current?.next(), []);
  const goToSlide = useCallback((slide: number) => ref.current?.scrollTo(slide), []);

  // Returned as a immutable to keep the ref isolated in sliderProps.
  // Mixing ref into the controller object triggers React's "cannot access ref during render" error.
  const sliderProps = { ref, onSlideChange };
  const controller = { currentSlide, isFirstSlide, isLastSlide, prev, next, goToSlide };

  return [sliderProps, controller] as const;
}
